import Radium from "radium";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import Router from "./store/router";
import configureStore from "./store/configure-store";
import Feeback from "./feedback";

const store = configureStore({});

ReactDOM.render(
  <Radium.StyleRoot>
    <Provider store={store}>
      <>
        <Router />
        <Feeback />
      </>
    </Provider>
  </Radium.StyleRoot>,
  document.getElementById("app")
);
